/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlAddIntegrationField
 */
export interface ControlAddIntegrationField {
    /**
     * 
     * @type {string}
     * @memberof ControlAddIntegrationField
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAddIntegrationField
     */
    value: string;
}

/**
 * Check if a given object implements the ControlAddIntegrationField interface.
 */
export function instanceOfControlAddIntegrationField(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function ControlAddIntegrationFieldFromJSON(json: any): ControlAddIntegrationField {
    return ControlAddIntegrationFieldFromJSONTyped(json, false);
}

export function ControlAddIntegrationFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAddIntegrationField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
    };
}

export function ControlAddIntegrationFieldToJSON(value?: ControlAddIntegrationField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
    };
}

